module.exports = __webpack_public_path__ + "media/images/main_back-db0de26d13ee37f84c7fc57e8da04ce4.png";